export default __webpack_public_path__ + "static/media/MNLogo.8ccb5098.png";